import 'bootstrap/js/dist/collapse';
import '../../blocks/heading-and-links-block/heading-and-links-block';
import './page-footer.scss';
import { AnalyticsService } from '../../typescript/common/analytics-service';

(function pageFooter() {
   
  const pageFooterContactLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('[data-component="page-footer-contact-link"]');
   
  const pageFooterCustomerServiceLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('[data-component="page-footer-customer-service-link"]');

  if ((pageFooterContactLinks && pageFooterContactLinks.length > 0) || (pageFooterCustomerServiceLinks && pageFooterContactLinks.length > 0)) {
    class PageFooter {
      public init() {
        this.trackPageFooterContactLinks();
        this.trackPageFooterCustomerServiceLinks();
      }

      private trackPageFooterCustomerServiceLinks() {
        if (!pageFooterContactLinks) {
          return;
        }

        pageFooterCustomerServiceLinks.forEach((link) => {
          link.addEventListener('click', () => {
            if (link.innerText) {
              AnalyticsService.addEvent(AnalyticsService.ContactUsCategory, 'Till Kundservice');
            }
          });
        });
      }

      private trackPageFooterContactLinks() {
        if (!pageFooterContactLinks) {
          return;
        }

        pageFooterContactLinks.forEach((link) => {
          link.addEventListener('click', () => {
            if (link.innerText) {
              AnalyticsService.addEvent(AnalyticsService.ContactUsCategory, 'Kontaktalternativ', link.innerText);
            }
          });
        });
      }
    }
    const component = new PageFooter();
    component.init();
  }
})();
